import { render } from "./nav.vue?vue&type=template&id=23cf12e9&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"

import "./nav.vue?vue&type=style&index=0&id=23cf12e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cf12e9"]])

export default __exports__